import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Select from "@material-ui/core/Select";
import * as React from "react";
import styles from "./Dropdown.scss";
import DropdownOption from "./DropdownOption/DropdownOption";

interface IProps {
    className?: string;
    selectedItem: string | number | undefined;
    children: React.ReactNode[];
    onChange: (key: string | number) => void;
}

interface IState {
    selectedItem: string | number | undefined;
}

class Dropdown extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedItem: props.selectedItem || (props.children[0] as DropdownOption).props.value
        };

        this.selectItem = this.selectItem.bind(this);
    }

    public selectItem(event: React.ChangeEvent<HTMLSelectElement>, child: React.ReactNode) {
        const menuItem = child as MenuItem;
        this.props.onChange(menuItem.props.value);
        this.setState({ selectedItem: menuItem.props.value });
    }

    public render() {
        return (
            <div className={`${styles.dropdown} ${this.props.className}`}>
                <Select className={styles.select} onChange={this.selectItem} value={this.state.selectedItem} variant="outlined">
                    {
                        this.props.children.map((child, i) => {
                            return (
                                <MenuItem key={(child! as DropdownOption).props.value} value={(child! as DropdownOption).props.value}>{(child! as DropdownOption).props.label}</MenuItem>
                            );
                        })
                    }
                </Select>
            </ div>
        );
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/Components/Dropdown/Dropdown.tsx